import React, { useRef } from 'react';
import { Box, BoxProps } from '@components/Box';
import { Columns } from '@components/Columns';
import { guestListData } from '@data-ts/pages/guest-list';
import ReactHtmlParser from 'react-html-parser';
import {
  OrganizingGuestsTextPairing,
  ResponsiveTextPairing,
  StyledBox,
  StyledSvg,
  StyledCloudImage,
} from '@sections/guest-list/OrganizingGuests/OrganizingGuests.styles';
import { useOnScreen } from '@hooks/useOnScreen';

interface OrganizingGuestsProps {
  backgroundColor: BoxProps['backgroundColor'];
}

export const OrganizingGuests: React.FC<OrganizingGuestsProps> = ({ backgroundColor }) => {
  const organizingGuestsData = guestListData.organizingGuests;
  const sectionId = 'Group_Your_Guests';
  const animationRef = useRef<HTMLDivElement>(null);
  const onScreen = useOnScreen(animationRef, '0px');
  return (
    <Box backgroundColor={backgroundColor} paddingBottom={[10, 10, 12]} id={sectionId}>
      <Columns>
        <Columns.Column offset="two" width="eight">
          <Box marginBottom={[8, 8, 10]} marginTop={[0, 0, 0, 0, 0]}>
            <OrganizingGuestsTextPairing
              alignment="center"
              title={ReactHtmlParser(organizingGuestsData.title)}
              titleColor="neutra6"
              titleVariant="hed72Hero"
              titleTagName="h2"
              body={organizingGuestsData.content}
              bodyVariant="dek24"
              bodyColor="neutra5"
            />
          </Box>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column width={6}>
          <div ref={animationRef}>
            <StyledBox marginRight={[0, 14]}>
              <StyledCloudImage alt={organizingGuestsData.altText} width="220px" height="100%" src="guest-list/plus-ones/plus-ones.jpg" />
              {onScreen ? (
                <StyledSvg width="80" height="345" viewBox="0 0 80 345" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect className="draw" x="1" y="1.5" width="78" height="342" rx="39" stroke="#2C2925" strokeWidth="2" />
                </StyledSvg>
              ) : null}
            </StyledBox>
          </div>
        </Columns.Column>
        <Columns.Column width={6}>
          <Box marginLeft={[0]}>
            <Box marginBottom={[9]} marginTop={[10, 0, 0]}>
              <ResponsiveTextPairing
                title={organizingGuestsData.plusOnes.title}
                titleColor="neutra6"
                titleVariant="sectionEyeBrow24"
                titleTagName="h3"
                body={organizingGuestsData.plusOnes.content}
                bodyVariant="dek20"
                bodyColor="neutra5"
              />
            </Box>
            <Box paddingTop={8}>
              <ResponsiveTextPairing
                title={organizingGuestsData.rsvpGroups.title}
                titleColor="neutra6"
                titleVariant="sectionEyeBrow24"
                titleTagName="h3"
                body={organizingGuestsData.rsvpGroups.content}
                bodyVariant="dek20"
                bodyColor="neutra5"
              />
            </Box>
          </Box>
        </Columns.Column>
      </Columns>
    </Box>
  );
};
